import React from "react"
import { SeoLink } from "../SeoLink/SeoLink"

export const Footer: React.FC<{ showLinks?: boolean }> = props => (
  <footer className="bg-white border-t border-gray-200"></footer>
)
